import React from 'react';

import './style.scss'
import '../styles/landing-page-styles.css'


const LandingChat = () => { 

    return(
        <div className='landingChatWrapper'>
            <div className='landingChatField'>
            <div className='landingCustomerQuestion landingChatQuestion'>
                <p className='landingCustomerQuestionText'>Does PhoneFix Pro do a free diagnostics?</p>
            </div>
            <div className='landingChatResponse landingChatQuestion'>
                <p className='landingChatResponseText'>Yes, it is absolutely free!</p>
            </div>
            <div className='landingCustomerQuestion landingChatQuestion'>
                <p className='landingCustomerQuestionText'>What will the diagnostic tell you?</p>
            </div>
            <div className='landingChatResponse landingChatQuestion'>
                <p className='landingChatResponseText landingChatQuestion'>Give valuable insight of the problem and the cost of the repair.</p>
            </div>
            <div className='landingCustomerQuestion landingChatQuestion'>
                <p className='landingCustomerQuestionText landingChatQuestion'>Repairs required after diagnostics ?</p>
            </div>
            <div className='landingChatResponse landingChatQuestion'>
                <p className='landingChatResponseText'>No, this is no-commitment</p>
            </div>
            </div>
        </div>
    );
};

export default LandingChat;